import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { tasksService } from '../api/tasks.service';
import type { MyPendingTasksParams, PendingTaskDto } from '../types';
import { TASK_KEYS } from './queryKeys';

export function useMyPendingTasks(params: MyPendingTasksParams = {}) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  const { data, isLoading, isError } = useQuery({
    queryKey: TASK_KEYS.myPendingTasks(orgId ?? ''),
    queryFn: ({ signal }) => tasksService.getMyPendingTasks(params, signal),
    staleTime: 60_000,
    enabled: !!orgId,
  });

  return {
    tasks: data?.items ?? ([] as PendingTaskDto[]),
    totalCount: data?.totalCount ?? 0,
    isLoading,
    isError,
  };
}
